import React, { memo } from "react";
import classNames from "classnames";

import "./style.scss";

import ZoomDialog from "./ZoomDialog";
import Strap from "./Strap";

import { useMainContext } from "../../store/Context";

const Product = () => {
  const context = useMainContext();

  const productClasses = classNames("Product__content", {
    remove: context.isMobile && context.product.dices.length === 1,
  });

  return (
    <div className="Product">
      <div className={productClasses}>
        <Strap />
        {!context.isMobile && <ZoomDialog />}
      </div>
    </div>
  );
};

export default memo(Product);
